import i61 from '../../img/before/61.jpg'
import i62 from '../../img/before/62.jpg'
import i63 from '../../img/before/63.jpg'
import i64 from '../../img/before/64.jpg'
import i65 from '../../img/before/65.jpg'
import i66 from '../../img/before/66.jpg'

export const before=[
    {
        "id" : 61 ,
        "title" : "سیب زمینی ",
        "price":"70",
        "desciption":"350 گرم سیب زمینی سرخ کرده، ادویه مخصوص ",
        "image" : i61
    },
    {
        "id" : 62 ,
        "title" : "پوتین هات داگ",
        "price":"100",
        "desciption":"350 گرم سیب زمینی سرخ کرده ، هات داگ ، پنیر گودا ",
        "image" : i62
    },
    {
        "id" : 63 ,
        "title" : "سیب زمینی و پنیر ",
        "price":"130",
        "desciption":"350 گرم سیب زمینی سرخ کرده ، پنیر موزارلا ، قارچ ",
        "image" : i63
    },
    {
        "id" : 64 ,
        "title" : "نان سیر",
        "price":"160",
        "desciption":"خمیر پیتزا پنجره ای ، پنیر موزارلا، سیر ",
        "image" : i64
    },
    {
        "id" : 65 ,
        "title" : "سالاد سزار سوخاری ",
        "price":"150",
        "desciption":"کاهو رسمی ، گوجه گیلاسی ، فیله مرغ سوخاری ، پنیر پارمسان ، نان کراستینو ، سس سزار",
        "image" : i65
    },
    {
        "id" : 66 ,
        "title" : "سالاد سزار گریل",
        "price":"140",
        "desciption":"کاهو رسمی ، گوجه گیلاسی ، فیله مرغ گریل شده ، پنیر پارمسان ، نان کراستینو ، سس سزار",
        "image" : i66
    },
   
]